import { usePrefersReducedMotion } from "@chakra-ui/react";
import { useCallback, useState } from "react";

type Playback = "auto" | "paused" | "playing";

export const usePlaybackToggle = () => {
  const prefersReducedMotion = usePrefersReducedMotion();
  const [playback, setPlayback] = useState<Playback>("auto");
  const isPlaying = playback === "playing" || (playback === "auto" && !prefersReducedMotion);
  const toggle = useCallback(() => setPlayback(isPlaying ? "paused" : "playing"), [isPlaying]);
  return { isPlaying, toggle };
};
